<template>
  <MainViewFrame>
    <div class="container">
      <div class="companyType" v-for="(companyItem,index) in data" :key="companyItem.pk">
        <div class="left" v-if="index===0">
          <span class="icon">
            <img :src="data[0].company_grade.image" alt="图片加载失败" />
          </span>
          <span class="text">{{data[0].company_grade.name}}</span>
        </div>
        <CompanyGradeItem :dic="companyItem" />
      </div>
    </div>
  </MainViewFrame>
</template>

<script>
import MainViewFrame from "./MainViewFrame.vue";
import CompanyGradeItem from "./CompanyGradeItem";

import { Utils } from "../utils";
import { types as CompanyTypes } from "@/store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "DetailCompanyType",
  components: {
    MainViewFrame,
    CompanyGradeItem
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      data: state => state.company.company_type.data,
      page: state => state.company.company_type.page,
      load_more: state => state.company.company_type.load_more,
      total_count: state => state.company.company_type.total_count
    })
  },
  methods: {
    ...mapActions({
      fetchCompanyTypeData: CompanyTypes.FETCH_LIST_COMPANY_TYPE
    }),

    handleScroll(e) {
      let page = this.page;
      let load_more = this.load_more;

      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollHeight <= height + scrollTop + 20) {
        if (load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchCompanyTypeData({
            page: page + 1,
            grade_id: that.grade_id
          });
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    if (this.$route.params.grade_id) {
      this.grade_id = this.$route.params.grade_id;
    }
    this.fetchCompanyTypeData({
      page: 1,
      grade_id: this.grade_id
    });
  }
};
</script>

<style lang="less" scoped>
.mainViewFrameContainer {
  .mainView {
    .container {
      border-radius:10px;
      .companyType:first-child{
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
      .companyType:last-child{
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      .companyType {
        background-color: #fff;
        padding-bottom: 10px;
        padding-top: 10px;
        .left {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 15px;
          margin-bottom: 10px;
          .icon {
            width: 30px;
          }
          .text {
            color: #333333;
            margin-left: 10px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
          }
        }
      }
    }
  }
}
</style>